import { Flex, TypographyProps } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import * as S from "./Title.styled";

import { SimpleSpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";
import { getSpeakerDisplayName } from "@/helpers/speaker/speaker.helpers";
import { SpeakerAvatarVariant } from "@/states/call/speakers/speakers.utility.decl";

interface MainContactHeadingProps {
  color: TypographyProps["color"];
  variant: SpeakerAvatarVariant;
  fullName?: string | null;
  number: string;
  companyName?: string | null;
}

export function MainContactHeading({
  variant,
  fullName,
  color,
  number,
  companyName,
}: MainContactHeadingProps) {
  const { t } = useTranslation();
  return (
    <Flex gap="xxxs">
      <SimpleSpeakerAvatar variant={variant} name={fullName} />
      <S.SpeakerName color={color}>
        {getSpeakerDisplayName(fullName, number)}
      </S.SpeakerName>
      {companyName && (
        <S.Text>
          ({t("call_details.at_company", { company: companyName })})
        </S.Text>
      )}
    </Flex>
  );
}
